



















import { Component, Vue, Prop } from 'vue-property-decorator';
import Modal from '@/components/common/Modal.vue';
import SellOfferForms from '@/components/trading/selloffer/SellOfferForms.vue';
import { SellOffer } from '@/store/sellOffer/types';
import { Getter, Action } from 'vuex-class';
import { Asset } from '@/store/asset/types';
import { UserWallet } from '@/store/wallet/types';

@Component({
  name: 'sell-offer-view',
  components: {
    Modal,
    SellOfferForms,
  },
})
export default class SellOfferView extends Vue {
  @Getter('asset/asset') asset?: Asset;
  @Getter('appState/isLoading') isLoading?: boolean;
  @Getter('wallet/userWallet') userWallet?: UserWallet;

  @Action('asset/fetchAsset') fetchAsset;

  async mounted() {
    const assetId = this.$route.query.asset_id;
    this.fetchAsset(assetId);
  }

  get lockedAccount() {
    return !!this.userWallet.locked_at;
  }
}
